/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from '../../../index-892d8eee.js';

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function promisify(api) {
  return function (arg) {
    return new Promise(function (resolve, reject) {
      var promisifyArg = arg;
      api(_extends$2({}, promisifyArg, {
        success: function success(res) {
          if (promisifyArg && typeof promisifyArg.success === 'function') {
            promisifyArg.success(res);
          }

          resolve(res);
        },
        onSuccess: function onSuccess(res) {
          if (promisifyArg && typeof promisifyArg.onSuccess === 'function') {
            promisifyArg.onSuccess(res);
          }

          resolve(res);
        },
        fail: function fail(res) {
          if (promisifyArg && typeof promisifyArg.fail === 'function') {
            promisifyArg.fail(res);
          }

          reject(res);
        },
        onFail: function onFail(res) {
          if (promisifyArg && typeof promisifyArg.onFail === 'function') {
            promisifyArg.onFail(res);
          }

          reject(res);
        },
        complete: function complete(res) {
          if (promisifyArg && typeof promisifyArg.complete === 'function') {
            promisifyArg.complete(res);
          }
        },
        onComplete: function onComplete(res) {
          if (promisifyArg && typeof promisifyArg.onComplete === 'function') {
            promisifyArg.onComplete(res);
          }
        }
      }));
    });
  };
}

var _excluded$1 = ["_ext"];

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var styleIn = function styleIn(options, baseName) {
  var _ref = options || {},
      _ref$_ext = _ref._ext,
      _ext = _ref$_ext === void 0 ? {} : _ref$_ext,
      rest = _objectWithoutPropertiesLoose$1(_ref, _excluded$1);

  return _extends$1({}, rest, _ext[baseName] || {});
};

function normalize(api, containerName) {
  return function (args) {
    return promisify(api)(styleIn(args, containerName));
  };
}

var CONTAINER_NAME = {
  WECHAT: 'wechatMiniProgram',
  ALIPAY: 'aliMiniApp',
  BYTE: 'bytedanceMicroApp',
  WEB: 'web',
  BAIDU: 'baiduSmartProgram',
  KWAI: 'kuaishouMiniProgram'
};

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var _excluded = ["phoneNumber"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var makePhoneCall$6 = function makePhoneCall(options) {
  if (isDingdingMiniapp) {
    dd.showCallMenu(options);
  } else {
    var phoneNumber = options.phoneNumber,
        ext = _objectWithoutPropertiesLoose(options, _excluded);

    my.makePhoneCall(_extends({}, ext, {
      number: phoneNumber
    }));
  }
};

var aliMiniAppModule = normalize(makePhoneCall$6, CONTAINER_NAME.ALIPAY);

var makePhoneCall$5 = function makePhoneCall(options) {
  var phoneNumber = options == null ? void 0 : options.phoneNumber;
  var a = document.createElement('a');
  a.href = "tel:" + phoneNumber;
  a.innerHTML = "tel:" + phoneNumber;
  a.style.display = 'none';
  document.body.appendChild(a);
  setTimeout(function () {
    a.click(); // remove

    setTimeout(function () {
      try {
        document.body.removeChild(a);
      } catch (e) {// ignore
      } finally {
        // eslint-disable-next-line @typescript-eslint/dot-notation
        options == null ? void 0 : options['success'](); // set resolved
      }
    }, 0);
  }, 0);
};

var webModule = normalize(makePhoneCall$5, CONTAINER_NAME.WEB);

var makePhoneCall$4 = function makePhoneCall(options) {
  wx.makePhoneCall(options);
};

var weChatModule = normalize(makePhoneCall$4, CONTAINER_NAME.WECHAT);

var makePhoneCall$3 = function makePhoneCall(options) {
  tt.makePhoneCall(options);
};

var bytedanceModule = normalize(makePhoneCall$3, CONTAINER_NAME.BYTE);

var makePhoneCall$2 = function makePhoneCall(options) {
  ks.makePhoneCall(options);
};

var kuaiShouModule = normalize(makePhoneCall$2, CONTAINER_NAME.KWAI);

var makePhoneCall$1 = function makePhoneCall(options) {
  swan.makePhoneCall(options);
};

var baiDuModule = normalize(makePhoneCall$1, CONTAINER_NAME.BAIDU);

/**
 * call phone
 * @param options
 */
function makePhoneCall(options) {
  if (isWeb) {
    return webModule(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule(options);
  } else if (isMiniApp) {
    return aliMiniAppModule(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule(options);
  } else {
    throw new Error('Uni API：makePhoneCall 暂不支持');
  }
}

function callPhone(params) {
    makePhoneCall(params);
}

export { callPhone as default };
